import React, { useState, useEffect } from 'react';
import { getHrisDashboard, getKaryawan } from '../../api';
import { Users, FileText, CheckCircle, AlertTriangle, BarChart3, DollarSign, BookOpen, Award } from 'lucide-react';

export default function HrisDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getHrisDashboard(), getKaryawan()])
      .then(([sRes]) => {
        setStats(sRes.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-loading"><div className="spinner-lg" /></div>;

  const cards = [
    { label: 'Total Karyawan', value: stats?.total_karyawan || 0, icon: Users, color: '#11cdef' },
    { label: 'Kontrak Aktif', value: stats?.kontrak_aktif || 0, icon: FileText, color: '#2dce89' },
    { label: 'Kontrak Kadaluwarsa', value: stats?.kontrak_kadaluwarsa || 0, icon: AlertTriangle, color: '#fb6340' },
    { label: 'Cuti Menunggu', value: stats?.cuti_menunggu || 0, icon: CheckCircle, color: '#f5365c' },
    { label: 'Cuti Bulan Ini', value: stats?.cuti_bulan_ini || 0, icon: BookOpen, color: '#06b6d4' },
    { label: 'Pelanggaran Aktif', value: stats?.pelanggaran_aktif || 0, icon: AlertTriangle, color: '#f59e0b' },
    { label: 'KPI Bulan Ini', value: stats?.kpi_bulan_ini || 0, icon: BarChart3, color: '#8965e0' },
    { label: 'Slip Gaji Bulan Ini', value: stats?.slip_gaji_bulan_ini || 0, icon: DollarSign, color: '#2dce89' },
    { label: 'Pelatihan Bulan Ini', value: stats?.pelatihan_bulan_ini || 0, icon: Award, color: '#11cdef' },
    { label: 'Total Penggajian', value: `Rp ${(stats?.total_penggajian || 0).toLocaleString('id-ID')}`, icon: DollarSign, color: '#f5365c' },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h2><Users size={24} /> HRIS Dashboard</h2>
        <p>Human Resource Information System</p>
      </div>

      <div className="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 16, marginTop: 24 }}>
        {cards.map((card, i) => (
          <div key={i} className="stat-card" style={{ background: 'var(--card-bg)', borderRadius: 12, padding: 20, border: '1px solid var(--border-color)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <div style={{ width: 40, height: 40, borderRadius: 10, background: card.color + '20', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <card.icon size={20} color={card.color} />
              </div>
            </div>
            <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 4 }}>{card.value}</div>
            <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{card.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
